var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBusinessManagerAssigned(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#21ff91;}\n\t.st2{fill:#FFFFFF;stroke:#11bd4f;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#11bd4f;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#11bd4f;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#11bd4f;}\n\t.st6{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 75,
    cy: 75,
    r: 71
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.7,88.65c0.39-1.87-1.78-4.21-3.24-4.62c0,0-9.13-3.87-15.42-6.44c-1.86,1.21-3.72,1.7-5.58,1.56 c-1.74-0.07-3.55-0.75-5.43-2.13L52.2,84.22c-1.14,0.77-1.96,1.86-2.24,3.49c-0.3,5.28-0.52,10.38-0.61,15.26 c-0.01,0.32,0.25,0.58,0.58,0.58l48.74,0c0.33,0,0.59-0.27,0.58-0.6L98.7,88.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.11,77.02c2.66-2.55,4.56-5.41,5.72-8.58l2.14-11.35c2.03-6.15-0.42-10.8-6.11-14.37 c-5.38-1.77-10.44-2.37-14.29,1.59c-4.35,0.79-7.29,3.53-5.55,12.78c-0.23,3.44,0.17,7.37,2.38,12.7l4.63,7.23 c1.81,1.25,3.62,1.99,5.43,2.13C76.42,79.22,78.31,78.49,80.11,77.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.01,55.82l1.02,0.22c0.43,0.1,0.83-0.25,0.82-0.69c-0.03-1.16,0.17-2.14,0.81-2.77 c0.23-0.22,0.58-0.23,0.84-0.06c4.2,2.8,10.14,2.35,16.89,0.37c0.21-0.06,0.44-0.02,0.61,0.11c1,0.8,1.69,1.69,1.94,2.71 c0.07,0.29,0.35,0.47,0.64,0.47c0.78,0.01,1.65,0.46,2.18,1.16"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "71.53,81.19 77.09,81.19 77.61,84.48 74.31,86.82 71.02,84.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "71.9,85.44 71,103.55 77.61,103.55 76.44,85.44  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 99.51,
    cy: 103.51,
    r: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.69,104.99l-1.48-1.48l1.48-1.48c0.05-0.05,0.05-0.13,0-0.19l-0.51-0.51c-0.05-0.05-0.13-0.05-0.19,0 l-1.48,1.48l-1.48-1.48c-0.05-0.05-0.13-0.05-0.19,0l-0.51,0.51c-0.05,0.05-0.05,0.13,0,0.19l1.48,1.48l-1.48,1.48 c-0.05,0.05-0.05,0.13,0,0.19l0.51,0.51c0.05,0.05,0.13,0.05,0.19,0l1.48-1.48l1.48,1.48c0.05,0.05,0.13,0.05,0.19,0l0.51-0.51 C101.74,105.13,101.74,105.05,101.69,104.99z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBusinessManagerAssigned);
export default __webpack_public_path__ + "static/media/noBusinessManagerAssigned.09ec27ab6073fc81d56b72d18a1cbefd.svg";
export { ForwardRef as ReactComponent };